module.exports = __webpack_public_path__ + "static/media/collapseIcon.0eb691f5.svg";